import type {
  BoolFlagDefinition,
  JsonFlagValue,
  NumberFlagDefinition,
  ObjectFlagDefinition,
  StringFlagDefinition,
} from './types.ts';

export const boolFlag = (key: string, defaultValue: boolean): BoolFlagDefinition =>
  ({ key, defaultValue, type: 'boolean' });

export const stringFlag = (key: string, defaultValue: string): StringFlagDefinition =>
  ({ key, defaultValue, type: 'string' });

export const numberFlag = (key: string, defaultValue: number): NumberFlagDefinition =>
  ({ key, defaultValue, type: 'number' });

export const objectFlag = <T extends JsonFlagValue>(key: string, defaultValue: T): ObjectFlagDefinition<T> =>
  ({ key, defaultValue, type: 'object' });
